import classNames from 'classnames/bind';
import styles from './form.module.scss';

const classesContext = classNames.bind(styles);

export default function FormError({ error }: { error: string }): JSX.Element {
  return <div className={classesContext(['form_error'])}>{error}</div>;
}
